import React, { useState } from "react";
import { Card, Form, Input, Button } from "antd";
import { LockOutlined } from "@ant-design/icons";
import { toast } from "react-toastify";
import axios from "axios";
import secureLocalStorage from "react-secure-storage";
import { useNavigate } from "react-router-dom";
import SideBar from "../component/SideBar";


const ResetPassword = () => {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const onFinish = async (values) => {
        const passwordRegex = /^(?=.*[0-9])[A-Z][a-zA-Z0-9]{7,}$/;

        if (!passwordRegex.test(values.new_password)) {
            toast.error(
                "Password must be at least 8 characters, start with a capital letter, and include a number"
            );
            return;
        }

        if (values.new_password !== values.new_password_confirmation) {
            toast.error("New password and confirmation do not match");
            return;
        }

        setLoading(true);
        try {
            const user = JSON.parse(secureLocalStorage.getItem("user"));
            const res = await axios.post(
                `${process.env.REACT_APP_API_URL}api/change-password/${user?.id}`,
                {
                    old_password: values.old_password,
                    new_password: values.new_password,
                    new_password_confirmation: values.new_password_confirmation,
                },
                { headers: { "Content-Type": "application/json" } }
            );

            if (res.data.status === true) {
                toast.success(res?.data?.message);
                setTimeout(() => {
                    navigate("/");
                }, 1000);
            } else {
                toast.error(res?.data?.message);
            }
        } catch (error) {
            toast.error(error.response?.data?.message || "Something went wrong!");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="flex min-h-screen bg-gray-100 pt-[160px] pb-[50px]">
            <div className="w-64 bg-brandBlue shadow-lg py-8 px-4 text-white rounded-tr-[10px] rounded-br-[10px]">
                <h2 className="text-2xl font-bold mb-10">My Account</h2>
                <SideBar />
            </div>
            <div className="flex-1 p-10 pt-0 pb-0">
                <Card className="w-full max-w-md shadow-lg rounded-xl">
                    <h1 className="text-2xl font-bold text-center mb-6 text-brandBlue">
                        Reset Password
                    </h1>

                    <Form layout="vertical" onFinish={onFinish}>
                        <Form.Item
                            label="Old Password"
                            name="old_password"
                            rules={[{ required: true, message: "Please enter your old password" }]}
                        >
                            <Input.Password
                                prefix={<LockOutlined />}
                                placeholder="Enter old password"
                            />
                        </Form.Item>

                        <Form.Item
                            label="New Password"
                            name="new_password"
                            rules={[{ required: true, message: "Please enter your new password" }]}
                        >
                            <Input.Password
                                prefix={<LockOutlined />}
                                placeholder="Enter new password"
                            />
                        </Form.Item>

                        <Form.Item
                            label="Confirm New Password"
                            name="new_password_confirmation"
                            dependencies={["new_password"]}
                            rules={[
                                { required: true, message: "Please confirm your new password" },
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        if (!value || getFieldValue("new_password") === value) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(
                                            new Error("The two passwords do not match!")
                                        );
                                    },
                                }),
                            ]}
                        >
                            <Input.Password
                                prefix={<LockOutlined />}
                                placeholder="Confirm new password"
                            />
                        </Form.Item>

                        <Button
                            type="primary"
                            htmlType="submit"
                            loading={loading}
                            className="w-full bg-brandBlue border-none mt-2"
                        >
                            Update Password
                        </Button>
                    </Form>
                </Card>
            </div>
        </div>
    );
}

export default ResetPassword